export default __webpack_public_path__ + "static/media/src_img_8.a54a2c36.jpg";